/**
 * Empreinte du moteur de calcul paie (Desktop ↔ Cloud).
 * DWP-01 / DWP-03 Phase 2 — stampée sur chaque bulletin pour détecter
 * un conflit offline→online (hash T0 ≠ T1 → proposer recalcul).
 *
 * Source unique : constantes `Taux.ts` + version app. Ne pas dupliquer côté API.
 */
import { getAppVersion } from './appVersion';
import {
  TAUX_CNAMGS,
  TAUX_CNSS,
  TAUX_TCS,
  SMIG,
  RMM,
  TCS_SEUIL_MENSUEL,
} from './Taux';
import { PARAMETRES_PAIE_COURANTS } from './ParametresPaieDates';

/** Matériau stable pour l’empreinte (taux légaux + version). */
export function engineVersionMaterial(): string {
  return [
    getAppVersion(),
    `cnss:${TAUX_CNSS.SALARIAL}/${TAUX_CNSS.PATRONAL}/${TAUX_CNSS.PLAFOND_MENSUEL}`,
    `cnamgs:${TAUX_CNAMGS.SALARIAL}/${TAUX_CNAMGS.PATRONAL}`,
    `tcs:${TAUX_TCS}/seuil:${TCS_SEUIL_MENSUEL}`,
    `smig:${SMIG}/rmm:${RMM}`,
    `irpp:${PARAMETRES_PAIE_COURANTS.date_effet}/${PARAMETRES_PAIE_COURANTS.baremeIrpp
      .map((t) => `${t.max ?? 'inf'}:${t.taux}:${t.deduction}`)
      .join(',')}/abatt:${JSON.stringify(PARAMETRES_PAIE_COURANTS.abattementFraisPro)}`,
    `attente:${JSON.stringify(PARAMETRES_PAIE_COURANTS.contributionsEnAttente)}`,
    `exo9111:${PARAMETRES_PAIE_COURANTS.exonerationArt9111Active}`,
  ].join('|');
}

/** Hash court déterministe (FNV-1a 32-bit hex) — pas de crypto propriétaire. */
export function computeEngineHash(material: string = engineVersionMaterial()): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < material.length; i++) {
    h ^= material.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return `eng_${(h >>> 0).toString(16).padStart(8, '0')}`;
}

/** Empreinte courante du moteur embarqué. */
export const ENGINE_HASH: string = computeEngineHash();

export function engineHashesDiffer(
  localHash: string | undefined | null,
  remoteHash: string | undefined | null,
): boolean {
  if (!localHash || !remoteHash) return false;
  return localHash !== remoteHash;
}
